import { c as _c } from "react/compiler-runtime";
import { Box, Center } from '@chakra-ui/react';
import { InvestorSearchBuilder } from '@src/components/sco/InvestorMatching/InvestorSearchBuilder';
import { GenericBlock } from '@src/components/sco/LayoutBlocks/GenericBlock';
import React from 'react';
export const GetStartedBlock = () => {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      children: "Get Started for Free"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <GenericBlock headingProps={t0}><Center><Box maxWidth="container.lg" width="full"><InvestorSearchBuilder /></Box></Center></GenericBlock>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};